/**
 * @desc 获取省/洲信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseStateResponseDto>>;
export function request(body: defs.basics.StateCheckRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/state/getStateList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
